import { createErrorHandler } from './createErrorHandler';
export const simpleErrorHandler = createErrorHandler((context, cause) => {
  return new Error(context, {
    cause
  });
});